<i18n src='@/locale/item-move-localization.json'></i18n>

<template>
    <v-data-table
        :headers="headers"
        :options.sync="options"
        :items="gridData"
        item-key="Id"
        :server-items-length="gridDataTotalCount"
        class="elevation-1"
        :footer-props="footerProps"
        must-sort
        dense
        :show-select="showSelect"
        single-select
        v-model="selectedItem"
    >
        <template v-slot:top>
            <v-toolbar
                flat
                color="white"
                v-if="!hideHeader"
            >
                <v-toolbar-title>Item Move</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
            </v-toolbar>
        </template>
        <template v-slot:header.FullName="{ header }">
            <v-text-field
                v-if="!filter || !filter.Kod"
                dense
                outlined
                hide-details="auto"
                v-model="localFilter.Name_Custom"
                @change="ReloadGrid"
                :label="header.text"
                class="mt-3"
                prepend-inner-icon="search"
            ></v-text-field>
            <span v-else>{{ header.text }}</span>
        </template>
        <template v-slot:item.Ang="{ item }">
            {{ item.Ang }}.{{ item.An }}
        </template>
        <template v-slot:item.ItemCode="{ item }">
            [{{ item.ItemType }}] {{ item.ItemCode }}
        </template>
        <template v-slot:item.action="{ item }">
            <v-btn class="my-2" @click="$emit('drugTreatmentUse',item)" dense depressed>
                ხარჯვა
            </v-btn>
        </template>
        <template v-slot:no-data>
            <v-btn color="primary" @click="ReloadGrid">
                {{ $t('Refresh') }}
            </v-btn>
        </template>
    </v-data-table>
</template>

<script>
import itemMoveService from '@/service/item-move-service';

export default {
    props: {
        hideHeader: Boolean,
        filter: Object,
        showSelect: Boolean
    },
    data() {
        return {
            footerProps: {
                itemsPerPageOptions: [10, 25, 50, 100],
                showFirstLastPage: true,
                firstIcon: 'first_page',
                lastIcon: 'last_page',
                prevIcon: 'navigate_before',
                nextIcon: 'navigate_next',
            },
            headers: [
                {text: this.$t('Account'), value: 'Ang', sortable: false},
                {text: this.$t('Amount'), value: 'Amount', sortable: false},
                {text: this.$t('Price'), value: 'Price', sortable: false},
                {text: this.$t('ItemCode'), value: 'Kod', sortable: false},
                {text: this.$t('Name'), value: 'FullName', sortable: false},
                {text: this.$t('MohProductOtherDetailsGeo'), value: 'MohProductOtherDetailsGeo', sortable: false},
                {text: '', value: 'action', sortable: false},
            ],
            options: {
                page: 1,
                itemsPerPage: 10,
            },
            gridData: [],
            gridDataTotalCount: 0,
            localFilter: {
                Kod: null,
                Name_Custom: null,
            },
            selectedItem: []
        }
    },
    computed: {
        selection() {
            if (this.selectedIndex >= 0) {
                return [ this.gridData[this.selectedIndex] ];
            }
            return [];
        }
    },
    mounted() {
        this.ReloadGrid();
    },
    watch: {
        filter: {
            handler(newValue, oldValue) {
                this.ReloadGrid();
            },
            deep: true
        }
    },
    methods: {
        ReloadGrid() {
            let filter = {
                ...this.localFilter,
                ...this.filter
            };
            itemMoveService
                .getData(this.options.page, this.options.itemsPerPage, filter)
                .then(resp => {
                    this.gridData = resp.data;
                    this.gridDataTotalCount = resp.total;
                    this.$emit('dataLoad')
                });
        },
        MoveSelectionUp() {
            if (this.gridData && this.gridData.length > 0) {
                if (this.selectedItem.length === 1) {
                    let index = this.gridData.indexOf(this.selectedItem[0]);
                    if (index > 0) {
                        this.selectedItem = [ this.gridData[index - 1] ];
                    }
                } else {
                    this.selectedItem = [ this.gridData[this.gridData.length - 1] ];
                }
            }
        },
        MoveSelectionDown() {
            if (this.gridData && this.gridData.length > 0) {
                if (this.selectedItem.length === 1) {
                    let index = this.gridData.indexOf(this.selectedItem[0]);
                    if (index + 1 < this.gridData.length) {
                        this.selectedItem = [ this.gridData[index + 1] ];
                    }
                } else {
                    this.selectedItem = [ this.gridData[0] ];
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
